import { downloadTextFile } from './downloadTextFile';

export const downloadCsvFile = (csvContent, filename) => {
	downloadTextFile(csvContent, filename, 'text/csv');
};
